import { render, staticRenderFns } from "./CospendNavigation.vue?vue&type=template&id=18a25ff4&scoped=true&"
import script from "./CospendNavigation.vue?vue&type=script&lang=js&"
export * from "./CospendNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CospendNavigation.vue?vue&type=style&index=0&id=18a25ff4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a25ff4",
  null
  
)

export default component.exports